export const DEX_TX_HISTORY_WIDGET_TYPE_ID = 'DexTxHistoryWidget';
